$('.dateTimePicker').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    timePicker: true,
    timePicker24Hour: true,
    timePickerIncrement: 5,
    locale: {
        "format": 'DD.MM.YYYY H:mm',
        "daysOfWeek": [
            'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
        ],
        "monthNames": [
            'Januar', 'Februar', 'März', 'April', 'Mai',
            'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
        ],
        "firstDay": 1,
        "applyLabel": "Speichern",
        "cancelLabel": "Abbrechen",
    },
});

$('.datePicker').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    locale: {
        "format": 'DD.MM.YYYY',
        "daysOfWeek": [
            'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
        ],
        "monthNames": [
            'Januar', 'Februar', 'März', 'April', 'Mai',
            'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
        ],
        "firstDay": 1,
        "applyLabel": "Speichern",
        "cancelLabel": "Abbrechen",
    },
});

// Datepicker that allows empty values (initially empty input remain empty on page load
// and filled inputs can be cleared using the keyboard and are not automatically repopulated)
$('.clearableDatePicker').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    locale: {
        "format": 'DD.MM.YYYY',
        "daysOfWeek": [
            'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
        ],
        "monthNames": [
            'Januar', 'Februar', 'März', 'April', 'Mai',
            'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
        ],
        "firstDay": 1,
        "applyLabel": "Speichern",
        "cancelLabel": "Abbrechen",
    },
    autoUpdateInput: false,
});

$('.clearableDatePicker').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD.MM.YYYY'));
});
